import { api, useApi } from "../../configuration/api/apiHelper";
import { BrowseHandymanQuery, HandymanViewModel, } from "../../configuration/api/apiSchema";

// Get Handyman list
export enum GET_HANDYMAN_LIST {
    REQUEST = "GET_HANDYMAN_LIST_REQUEST",
    SUCCESS = "GET_HANDYMAN_LIST_SUCCESS",
    FAILURE = "GET_HANDYMAN_LIST_FAILURE"
}

export const getHandymanListRequest = () => {
    return {
        type: GET_HANDYMAN_LIST.REQUEST
    };
};

export const getHandymanListRequestAction = () => ({
    type: GET_HANDYMAN_LIST.REQUEST
});

export const getHandymanListSuccessAction = (handymanList: HandymanViewModel[]) => ({
    type: GET_HANDYMAN_LIST.SUCCESS,
    handymanList
});

export const getHandymanListFailureAction = (error: string) => ({
    type: GET_HANDYMAN_LIST.FAILURE,
    error
});

export const getHandymanList = (query: BrowseHandymanQuery) => {
    return async (dispatch: any) => {
        dispatch(getHandymanListRequestAction());

        try {
            const response = await useApi(() =>
                api.browseHandyman.browseHandymanCreate(query)
            );

            if (response.result) {
                dispatch(getHandymanListSuccessAction(response.result));
            } else {
                dispatch(getHandymanListFailureAction("Failed to fetch handyman list"));
            }
        } catch (error: any) {
            dispatch(getHandymanListFailureAction(error.message || "An error occurred"));
        }
    };
};